import { createSlider } from "../../../../assets/js/slider.js";

function initFunctieSlider() {
	document.querySelectorAll(".functie_slider-layout").forEach((layout) => createSlider(layout, ".functie-swiper"));
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initFunctieSlider);
} else {
	initFunctieSlider();
}
